<template>
  <div>
    <b-alert variant="danger"
             class="p-5"
             dismissible
             :show="error.isVisible"
             @dismissed="error.isVisible=false">
      <i18n :path="error.path"
            tag="div">
        <b-link href="mailto:support@meine-vertraege.net" place="supportLink">{{ $t('message.support.email') }}</b-link>
      </i18n>
    </b-alert>
    <b-card class="rounded-0">
      <h4>{{ $t('message.signUpConfirm.title') }}</h4>
      <p>{{ $t('message.signUpConfirm.message') }}</p>
      <b-form @submit.prevent="submit">
        <b-form-row class="mt-3">
          <b-col>
            <b-form-group :state="$v.confirmData.verificationCode.$error ? false : null"
                          :invalid-feedback="$t('error.signUpConfirm.verificationCode')">
              <b-form-input v-model="confirmData.verificationCode"
                            :placeholder="$t('message.signUpConfirm.input.placeholder.verificationCode')"
                            :state="$v.confirmData.verificationCode.$error ? false : null"
                            @change="$v.confirmData.verificationCode.$touch()">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row class="mt-4">
          <b-col>
            <i18n path="message.signUpConfirm.again" tag="p">
              <b-link href="#" place="resendLink" @click="resendConfirmationCode">{{
                $t('message.signUpConfirm.btn.resend') }}
              </b-link>
              <b-link href="mailto:support@meine-vertraege.net" place="supportLink">{{ $t('message.support.email') }}
              </b-link>
            </i18n>
          </b-col>
        </b-form-row>
        <b-form-row class="mt-4">
          <b-col>
            <b-btn variant="link" @click="back">{{ $t('message.signUpConfirm.btn.back') }}</b-btn>
          </b-col>
          <b-col class="text-right">
            <b-btn variant="primary" type="submit">{{ $t('message.signUpConfirm.btn.send') }}</b-btn>
          </b-col>
        </b-form-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
  import {required} from 'vuelidate/lib/validators'

  export default {
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.confirmData.email = to.query.email
        vm.fromPath = from.path
      })
    },
    data () {
      return {
        confirmData: {
          email: null,
          verificationCode: null
        },
        error: {
          path: '',
          isVisible: false
        },
        fromPath: '/'
      }
    },
    methods: {
      back () {
        this.$router.replace(this.fromPath)
      },
      resendConfirmationCode () {
        this.$store.dispatch('resendConfirmSignUpCode', this.confirmData.email)
          .catch((err) => {
            this.error.code = err.code
            this.error.isVisible = true
          })
      },
      submit () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.$store.dispatch('confirmSignUp', this.confirmData)
            .then(() => {
              this.showSuccessMsg({
                message: this.$t('message.signUpConfirm.activated')
              })
              this.$router.push({path: '/signin', query: {email: this.confirmData.email}})
            })
            .catch((err) => {
              if (err && err.code === 'UserNotFoundException') {
                this.error.path = 'error.signUpConfirm.resend'
              } else if (err && err.code === 'ExpiredCodeException') {
                this.error.path = 'error.signUpConfirm.submit'
              } else {
                this.error.path = 'error.signUpConfirm.submit'
              }
              this.error.isVisible = true
            })
        }
      }
    },
    validations: {
      confirmData: {
        verificationCode: {
          required
        }
      }
    },
    notifications: {
      showSuccessMsg: {
        type: 'success'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/SignUpConfirm.vue